<div class="detalhes__experiencia">
  <div class="experiencia__sem__quantidade" *ngIf="experienciaEsgotada">
    <div class="exibir__paragrafo">
      <img
        class="sem__quantidade__icone"
        src="assets/images/icons/no_ticket.png"
      />
      <div class="sem__quantidade__textos">
        <p class="sem__quantidade__texto_principal">
          Momento Especial Esgotado...
        </p>
        <p class="sem__quantidade__texto_principal_negrito">
          Mas fique tranquilo! Dia
        </p>
        <p class="sem__quantidade__texto_data_negrito">
           {{dataProximoLoteDisponivel}}
        </p>
        <p class="sem__quantidade__texto_principal_negrito">
          teremos este momento disponível novamente.
        </p>
      </div>
    </div>
  </div>

  <div class="visao__geral">
    <div class="card__imagem">
      <app-texto-tag [tag]="tag" [pageIndex]="false"></app-texto-tag>
      <img class="experiencia__imagem" [src]="imagemSrc" />
    </div>

    <div class="card__descricao">
      <div class="card__header">
        <div
          class="experiencia__nivel"
          *ngFor="let nivel of obterNiveisOrdenados()"
          [ngClass]="obterClasse(nivel.descricaoNivel)"
        >
          <p class="nivel__descricao lovers-font--leahlee">
            {{ nivel.descricaoNivel | lowercase }}
          </p>
        </div>
      </div>

      <div class="card__body">
        <p
          class="header__titulo"
          [ngClass]="{ 'titulo--grande': nome.length >= 40 }"
        >
          {{ nome }}
        </p>
        <p class="body__descricao">
          {{ descricao }}
        </p>
        <div
          class="experiencia__unidades"
          (click)="onClickUnidadesDisponiveis()"
          *ngIf="listaEnderecos.length > 0"
        >
          <img
            class="location__icone"
            src="assets/images/icons/location_red.png"
          />
          <p class="unidades__disponiveis">
            Veja os Locais Disponíveis
            <img
              class="unidades__icone"
              src="assets/images/icons/avancar.png"
            />
          </p>
        </div>
        <!-- <p class="body__info">
              Para o resgate dessa experiência, consulte os
              <strong>locais disponíveis!</strong>
            </p> -->
        <!-- <div class="experiencia__unidades" style="color: #fff" *ngIf="listaEnderecos.length == 0">
          <p class="unidades__disponiveis">Local indisponível</p>
        </div> -->
      </div>

      <div class="card__footer">
        <div class="experiencia__compra__container">
          <div class="buttons__footer">
            <div class="campo__pontos">
              <div class="pontos">
                <lovers-pontos
                  id="tamanho-button"
                  [pontuacao]="pontuacaoFinal"
                  [minimo]="true"
                  [bordaDiferente]="true"
                  [botaoCard]="true"
                  [exibirVoceTem]="false"
                  tipo="experiencia"
                >
                </lovers-pontos>
              </div>
            </div>
            <div
              class="container__disable__message"
              *ngIf="!membroPertenceAoNivel()"
            >
              <app-dynamic-disable-message
                [tipoDisable]="messageDisabled"
              ></app-dynamic-disable-message>
            </div>
            <div class="campo__resgate" *ngIf="membroPertenceAoNivel()">
              <button
                class="lovers-button"
                id="tamanho-button"
                (click)="validarCondicaoResgate()"
                [disabled]="!possuiQuantidadeLoteAtual"
                [ngClass]="{
                  'lovers--disabled': lotes.length === 0
                }"
              >
                Resgatar
                <i
                  *ngIf="resgatandoExperiencia"
                  class="fa fa-spinner fa-spin"
                ></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <lovers-popup
  [exibir]="popupExperienciaEsgotada"
  (onClose)="popupExperienciaEsgotada = false"
  tamanho="pequeno"
>
  <div class="popup__geral">
    <div class="popup__header">
      <p class="header__title">Experiência indisponível</p>
    </div>
    <div class="popup__body">
      <div class="descricao">
        <h6 class="mb-0">
          <span>Experiência indisponível para resgate no momento.</span>
        </h6>
      </div>
    </div>
  </div>
</lovers-popup> -->

<lovers-popup
  [exibir]="abrirPopupResgate"
  (onClose)="abrirPopupResgate = false"
>
  <div class="popup__header">
    <p class="header__title">Resgatar momento especial</p>
  </div>
  <div class="popup__body" *ngIf="quantidadePorMembro > 0">
    <p class="resgate__confirmacao" *ngIf="tipo === 1">
      Você deseja utilizar os seus Cacaus para resgatar essa experiência?
    </p>

    <div class="resgate__data" *ngIf="tipo === 2 || tipo === 3 || tipo === 5">
      <div
        id="data-mes"
        class="data__mes"
        #elemt
        (mousedown)="startDragging($event, false, elemt)"
        (mouseup)="stopDragging($event, false)"
        (mouseleave)="stopDragging($event, false)"
        (mousemove)="moveEvent($event, elemt)"
      >
        <div
          class="mes__content"
          *ngFor="let lote of experienciaLotes; let i = index"
          (click)="selecionarMesLote(i)"
        >
          <p
            class="content__nome"
            [ngClass]="{ 'mes--selecionado': i === idLoteSelecionado }"
          >
            {{ lote.descricao }}
          </p>
        </div>
      </div>
      <div class="data__dias">
        <div
          class="dias__dia"
          *ngFor="
            let data of experienciaLotes[idPosicaoLoteSelecionado].datas;
            let i = index
          "
          [ngClass]="{ 'dia--selecionado': i === idDataSelecionada }"
          (click)="selecionarData(i)"
        >
          <p class="dia__semana">
            {{ data.diaSemana }}
          </p>
          <p class="dia__numero">{{ data.dia }}</p>
        </div>
      </div>

      <div class="data__horarios" *ngIf="idDataSelecionada !== -1">
        <div
          class="horarios__horario"
          *ngFor="
            let horario of experienciaLotes[idPosicaoLoteSelecionado].datas[
              idDataSelecionada
            ].horarios
          "
          (click)="selecionarLote(horario)"
          [ngClass]="{
            'horario--selecionado': horario.id === loteSelecionado?.id
          }"
        >
          <p class="horario__hora">{{ horario.horaDoEvento }}</p>
        </div>
      </div>

      <div
        class="resgate__endereco"
        *ngIf="
          loteSelecionado !== null && loteSelecionado.parceiroEndereco !== null
        "
      >
        <div class="endereco__icone">
          <img
            src="assets/images/icons/location_red.png"
            class="icone__imagem"
          />
        </div>
        <div class="endereco__nome">
          <p class="nome__title">{{ definirTituloEndereco() }}</p>
          <p class="nome__lugar">{{ definirDescricaoEndereco() }}</p>
        </div>
      </div>
    </div>

    <div
      class="resgate__multiplos__enderecos"
      *ngIf="(tipo === 3 && loteSelecionado !== null) || tipo === 6"
    >
      <p>Selecione o local para aproveitar essa experiência:</p>

      <div class="enderecos__busca">
        <div class="lovers-input__container">
          <label class="lovers-label">CEP</label>
          <input
            type="tel"
            class="lovers-input"
            mask="00000-000"
            placeholder="06695-570"
            [(ngModel)]="cep"
            [ngClass]="{ disabled: buscandoEndereco }"
          />
        </div>

        <div class="lovers-input__container">
          <label class="lovers-label">Número</label>
          <input
            type="tel"
            class="lovers-input"
            mask="0*"
            placeholder="140"
            [(ngModel)]="numero"
            [ngClass]="{ disabled: buscandoEndereco }"
          />
        </div>

        <div class="busca__botao">
          <button
            class="lovers-button"
            type="button"
            (click)="buscarEndereco()"
            [ngClass]="{ disabled: buscandoEndereco }"
          >
            <i *ngIf="!buscandoEndereco" class="fa fa-search"></i>
            <i *ngIf="buscandoEndereco" class="fa fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>
    </div>

    <div
      class="resgate__endereco"
      *ngIf="
        (tipo === 3 || tipo === 4 || tipo === 6) && enderecosLote.length > 0
      "
    >
      <div
        class="endereco__enderecos"
        [ngClass]="{
          enderecos__small: tipo === 3,
          enderecos__medio: tipo === 6
        }"
      >
        <div class="enderecos__busca_resgate">
          <div class="lovers-input__container">
            <label class="lovers-label">CEP</label>
            <input
              type="tel"
              class="lovers-input"
              mask="00000-000"
              placeholder="06695-570"
              [(ngModel)]="cep"
              [ngClass]="{ disabled: buscandoEndereco }"
            />
          </div>

          <div class="lovers-input__container">
            <label class="lovers-label">Número</label>
            <input
              type="tel"
              class="lovers-input"
              mask="0*"
              placeholder="140"
              [(ngModel)]="numero"
              [ngClass]="{ disabled: buscandoEndereco }"
            />
          </div>

          <div class="busca__botao">
            <button
              class="lovers-button"
              type="button"
              (click)="buscarEnderecoLote()"
              [ngClass]="{ disabled: buscandoEndereco }"
            >
              <i *ngIf="!buscandoEndereco" class="fa fa-search"></i>
              <i *ngIf="buscandoEndereco" class="fa fa-spinner fa-spin"></i>
            </button>
          </div>
        </div>
        <div
          class="resgate__endereco endereco__lote"
          *ngFor="let lote of enderecosLote"
          [ngClass]="{
            'lote--selecionado':
              enderecoSelecionado !== null && lote.id === enderecoSelecionado.id
          }"
          (click)="selecionarEndereco(lote)"
        >
          <div class="endereco__icone">
            <img
              src="assets/images/icons/location_red.png"
              class="icone__imagem"
            />
          </div>
          <div class="endereco__nome">
            <p class="nome__title">{{ definirTitulo(lote) }}</p>
            <p class="nome__lugar">
              {{ definirDescricao(lote) }}
            </p>
          </div>
          <div class="endereco__distancia" *ngIf="tipo === 3">
            <p class="distancia">
              {{
                formatarValorParaDuasCasasDecimais(
                  lote.parceiroEndereco.distancia
                )
              }}
              KM
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="resgate__acompanhantes" *ngIf="quantidadeAcompanhantes > 0">
      <p class="acompanhantes__titulo">Acompanhantes</p>
      <p class="acompanhantes__Descrição">
        Você pode adicionar {{ quantidadeAcompanhantes > 1 ? "até" : "" }}
        {{ quantidadeAcompanhantes }} acompanhante{{
          quantidadeAcompanhantes > 1 ? "s" : ""
        }}
        para aproveitar essa incrível experiência com você!
      </p>

      <div class="acompanhantes__container">
        <div
          class="acompanhantes__acompanhante"
          *ngFor="let acompanhante of acompanhantes; let i = index"
        >
          <div class="acompanhante__icone">
            <img
              src="assets/images/icons/person_orange.png"
              class="icone__img"
            />
          </div>

          <div class="acompanhante__info">
            <!-- <p class="info__acompanhante">Acompanhante {{ i + 1 }}</p> -->

            <div class="lovers-input__container acompanhante__nome__input">
              <label for="" class="lovers-label">Nome completo</label>
              <input
                type="text"
                class="lovers-input"
                placeholder="Nome completo"
                [(ngModel)]="acompanhante.nome"
              />
            </div>

            <div class="lovers-input__container acompanhante__cpf__input">
              <label for="" class="lovers-label">CPF</label>
              <input
                type="text"
                class="lovers-input"
                mask="000.000.000-00"
                placeholder="___.___.___-__"
                [(ngModel)]="acompanhante.documento"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="lovers-checkbox__container" *ngIf="quantidadePorMembro > 0">
    <input
      type="checkbox"
      name="termos"
      id="termos"
      [(ngModel)]="aceiteRegras"
    />
    <label class="" for="termos">
      Li e concordo com as regras de resgate, assim como as informações e locais
      da experiência.
    </label>
  </div>

  <div class="experiencia__sem__quantidade" *ngIf="limiteAtingido || quantidadePorMembro <= 0">
    <div class="exibir__paragrafo">
      <img
        class="sem__quantidade__icone"
        src="assets/images/icons/no_ticket.png"
      />
      <div class="sem__quantidade__textos">
        <p class="sem__quantidade__texto_principal">
          Você  atingiu a quantidade máxima de resgates desse Momento Especial.
        </p>
        <div class="sem__quantidade__textos" *ngIf="dataProximoLoteDisponivel != null && dataProximoLoteDisponivel != ''">
          <p class="sem__quantidade__texto_principal_negrito">Volte Dia </p><p class="sem__quantidade__texto_data_negrito">{{dataProximoLoteDisponivel}} </p><p class="sem__quantidade__texto_principal_negrito">para resgatar novamente.</p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="quantidadePorMembro > 0 && this.idLoteSelecionado > 0"
    class="popup__footer"
    [ngClass]="{
      disabled:
        ((tipo === 2 || tipo === 5) && loteSelecionado === null) ||
        (tipo === 3 &&
          (loteSelecionado === null || enderecoSelecionado === null)) ||
        (tipo === 4 && enderecoSelecionado === null) ||
        (tipo === 6 && enderecoSelecionado === null) ||
        !aceiteRegras
    }"
  >
    <div class="footer__compra" *ngIf="quantidadePorMembro > 0">
      <div class="pontos">
        <lovers-pontos
          id="tamanho-button"
          [pontuacao]="pontuacaoLoteFinal"
          [minimo]="true"
          [bordaDiferente]="true"
          [botaoCard]="true"
          [exibirVoceTem]="false"
          tipo="experiencia"
        >
        </lovers-pontos>
      </div>

      <div class="quantidade">
        <lovers-contador
          id="tamanho-button"
          [valorMinimo]="1"
          [valorMaximo]="maximoPopup"
          [valorAtual]="loteQuantidadeSelecionada"
          (onValueChanged)="onQuantidadeLoteChange($event)"
        >
        </lovers-contador>
      </div>

      <div></div>

      <div class="div__resgatar">
        <button
          class="lovers-button"
          id="tamanho-button"
          (click)="resgatarExperiencia()"
          [disabled]="
            membroCacaus < pontuacaoLoteFinal || resgatandoExperiencia
          "
          [ngClass]="{
            'lovers--disabled':
              membroCacaus < pontuacaoLoteFinal || resgatandoExperiencia
          }"
        >
          Resgatar
          <i *ngIf="resgatandoExperiencia" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>
    </div>
  </div>
</lovers-popup>

<lovers-popup
  [exibir]="exibirPopupResgatado"
  (onClose)="irParaMinhasExperiencias()"
>
<div class="popup__img_icon_center">
  <img class="popup__img_icon" src="assets/images/icons/ticket_svgrepo.png" />
</div>

<div class="popup__subheader">
  <p class="header__title">Resgate concluído!</p>
</div>

  <div class="popup__body_center" *ngIf="experienciaResgatada !== undefined">
    <p>Seu momento especial foi resgatado, aproveite o seu momento!</p>
    <!-- <p *ngIf="experienciaResgatada.tipo == 1">
      Vá até a loja mais próxima e tenha o benefício diretamente no caixa!
    </p>
    <p *ngIf="experienciaResgatada.tipo == 2">
      Aguarde o recebimento da confirmação com as orientações de uso!
    </p> -->
    <div class="popup__body_cupom" *ngIf="experienciaResgatada.cupons != undefined && experienciaResgatada.cupons != null && experienciaResgatada.cupons.length > 0">
      <div *ngIf="experienciaResgatada.cupons.length == 1" class="popup__body_cupom_unico">
        <p *ngFor="let item of experienciaResgatada.cupons" class="popup__paragrafo_cupom_unico">{{ item }}</p>
      </div>

      <div *ngIf="experienciaResgatada.cupons.length > 1" class="popup__body_cupom_multiplo_parent">
        <div *ngFor="let item of experienciaResgatada.cupons" class="popup__body_cupom_multiplo">
          <p class="popup__paragrafo_cupom_multiplo">{{ item }}</p>
        </div>
      </div>
    </div>
    <div class="div__mensagem_resgate" [innerHTML]="this.mensagemResgate"></div>
  </div>

  <div class="popup__footer">
    <button
      class="lovers-button button__resgatado"
      (click)="irParaMinhasExperiencias()"
    >
      Ir para minhas experiências
    </button>
  </div>
</lovers-popup>

<lovers-popup
  *ngIf="condicaoResgate"
  [exibir]="exibirPopupCondicoesResgate"
  (onClose)="exibirPopupCondicoesResgate = false"
>
  <div class="popup__header">
    <p class="header__title">{{ condicaoResgate.tituloPopup }}</p>
  </div>

  <div class="popup__body">
    <div
      class="div__mensagem_resgate"
      [innerHTML]="condicaoResgate.mensagem"
    ></div>
  </div>

  <div class="popup__footer footer__resgate">
    <button
      class="lovers-button-no-background button__condicoesResgate"
      (click)="exibirPopupCondicoesResgate = false"
    >
      Cancelar
    </button>
    <button
      class="lovers-button-gradient button__condicoesResgate"
      (click)="abrirLink(condicaoResgate.url)"
    >
      {{ condicaoResgate.tituloBotao }}
    </button>
  </div>
</lovers-popup>
